import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";

// 默认查询数据
export const DEFAULT_QUERY_DATA = {
    ChannelCreditedTimeId: undefined,
    CountryId: undefined,
};

// 默认分页数据
export const DEFAULT_PAGE_DATA = {
    Page: 1,
    PageSize: 10,
    Total: 0,
};

// 生成查询表单配置
export const generateQueryFormConfig = (options: any): FormConfigType => {
    return [
        {
            title: "通道时效",
            field: "ChannelCreditedTimeId",
            type: "select",
            placeholder: "请选择通道时效",
            options: options?.creditedTimeOptions || [],
            fieldNames: { label: 'name', value: 'id' },
            allowClear: true,
            style: {
                width: 200
            }
        },
        {
            title: "国家",
            field: "CountryId",
            type: "select",
            placeholder: "请选择国家",
            options: options?.countryOptions || [],
            fieldNames: { label: 'name', value: 'id' },
            allowClear: true,
            style: {
                width: 200
            }
        },
    ];
};

// 生成表格列配置
export const generateTableColumns = (): ColumnsType => {
    return [
        {
            title: "ID",
            dataIndex: "Id",
            key: "Id",
        },
        {
            title: "通道名称",
            dataIndex: ["ChannelCreditedTime", "Channel","Name"],   // ✔ 读取 Channel.Name
            key: "ChannelCreditedTimeChannelName",
        },
        {
            title: "通道时效",
            dataIndex: ["ChannelCreditedTime", "Name"],
            key: "ChannelCreditedTimeName",
        },
        {
            title: "国家",
            dataIndex: ["Country", "NameCn"],
            key: "CountryName",
        },
        {
            title: "手续费",
            dataIndex: "ExchangeFeeRate",
            key: "ExchangeFeeRate",
        },
        {
            title: "手续费限时减免",
            dataIndex: "ExchangeFeeDiscount",
            key: "ExchangeFeeDiscount",
        },
        {
            title: "通道费",
            dataIndex: "ServiceFee",
            key: "ServiceFee",
        },
        {
            title: "通道费限时减免",
            dataIndex: "ServiceFeeDiscount",
            key: "ServiceFeeDiscount",
        },
        {
            title: "排序",
            dataIndex: "Sort",
            key: "Sort",
        },
        {
            title: "最小限额",
            dataIndex: "MinLimit",
            key: "MinLimit",
        },
        {
            title: "最大限额",
            dataIndex: "MaxLimit",
            key: "MaxLimit",
        },
        {
            title: "工作时间",
            dataIndex: "WorkTime",
            key: "WorkTime",
        },
        {
            title: "工作时间英文",
            dataIndex: "WorkTimeEn",
            key: "WorkTimeEn",
        },
    ];
};
